import React from "react";
import { LogOut, ShareScreen, MuteAll } from "./Actions";
import { useSelector } from "react-redux";

function RoomActions(props) {
  const room = useSelector((state) => state.room);
  const userData = useSelector((state) => state.auth.userData);

  return (
    <>
      {props.mute ? (
        userData.data &&
        userData.data.UserRole === "Instructor" && <MuteAll {...props} />
      ) : (
        <>
          <ShareScreen {...props} />
          <LogOut {...props} />
        </>
      )}
    </>
  );
}

export default RoomActions;
